import { MarketTrades, SpotSymbol } from 'api/v1/market'
import { SpotOrderRecord, TradingFeeRates } from 'api/v1/spot'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import {
  CreateOrderOption,
  LastInputAmountType,
  OrderDirection,
  OrderModeDetails,
  OrderModeNames,
  SpotClosedOrders,
  SpotMatchClearingsType,
  SpotOrderTabType,
} from './types'

export function useSpotSymbols() {
  const market = useSelector<RootState, MarketTrades>(
    (state) => state.market.trades
  )
  return market.spotsSymbols
}
export function useCurrentSpotSymbol(): Partial<SpotSymbol> {
  const currentSpotSymbol = useSelector<RootState, number>(
    (state) => state.spot.currentSpotSymbol
  )
  const market = useSelector<RootState, MarketTrades>(
    (state) => state.market.trades
  )
  return useMemo(() => {
    return market.spotsSymbols.find((v) => v.id === currentSpotSymbol) ?? {}
  }, [currentSpotSymbol, market])
}
export function useSpotOpenOrders() {
  return useSelector<RootState, SpotOrderRecord[]>(
    (state) => state.spot.openOrders
  )
}
export function useSpotClosedOrders() {
  return useSelector<RootState, SpotClosedOrders>(
    (state) => state.spot.closedOrders
  )
}
export function useSpotMatchClearings() {
  return useSelector<RootState, SpotMatchClearingsType>(
    (state) => state.spot.matchClearings
  )
}
export function useSpotBadgeOrder() {
  return useSelector<RootState, boolean>((state) => state.spot.badgeOrder)
}
export function useSpotBadgeTrade() {
  return useSelector<RootState, boolean>((state) => state.spot.badgeTrade)
}
export function useSpotFeeRates() {
  return useSelector<RootState, TradingFeeRates | undefined>(
    (state) => state.spot.feeRates
  )
}
export function useCreateOrderOption() {
  return useSelector<RootState, CreateOrderOption>(
    (state) => state.spot.createOrderOption
  )
}
export function useSpotSelectedOrderMode() {
  const currentOrderMode = useSelector<RootState, OrderModeNames>(
    (state) => state.spot.orderMode
  )
  return useMemo(() => {
    return (
      OrderModeDetails.find((v) => v.name === currentOrderMode) ??
      OrderModeDetails[0]
    )
  }, [currentOrderMode])
}
export function useLastInputAmountType() {
  return useSelector<RootState, LastInputAmountType>(
    (state) => state.spot.lastInputAmountType
  )
}
export function useSpotOrderDirection() {
  return useSelector<RootState, OrderDirection>(
    (state) => state.spot.orderDirection
  )
}
export function useCancelSpotPendingIds() {
  return useSelector<RootState, number[]>(
    (state) => state.spot.cancelSpotPendingIds
  )
}
export function useCancelAllSpotState() {
  return useSelector<RootState, boolean>(
    (state) => state.spot.cancelAllOpenSpotState
  )
}
export function useCurrentSpotOrderTab() {
  return useSelector<RootState, SpotOrderTabType>(
    (state) => state.spot.orderTab
  )
}
export function useSpotPostOnly() {
  return useSelector<RootState, boolean>((state) => state.spot.postOnly)
}
